import { render } from "./InternthanksView.vue?vue&type=template&id=99edb39e"
import script from "./InternthanksView.vue?vue&type=script&lang=js"
export * from "./InternthanksView.vue?vue&type=script&lang=js"

import "./InternthanksView.vue?vue&type=style&index=0&id=99edb39e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__